export default __webpack_public_path__ + "static/media/arena_hub.ff053d02.png";